import { createFileRoute } from "@tanstack/react-router"
import { BackofficeScheduledReports } from "modules/backoffice/components/scheduledReports"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import {
  BackofficeScheduledReportsFilterBySchema,
  BackofficeScheduledReportsSortSchema,
} from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduledReportsStatus = ["active", "paused"] as const
export type ScheduledReportsStatus = (typeof ScheduledReportsStatus)[number]

// eslint-disable-next-line react-refresh/only-export-components
export const BackofficeScheduledReportsSearchSchema = PaginationSearchSchema.merge(
  SearchQuerySchema,
)
  .merge(BackofficeScheduledReportsSortSchema.shape.sortBy.unwrap())
  .merge(BackofficeScheduledReportsFilterBySchema)
  .extend({
    status: z.enum(ScheduledReportsStatus).default("active"),
  })

export const Route = createFileRoute("/_base/_auth/backoffice/scheduledReports/list")({
  component: BackofficeScheduledReports,
  validateSearch: (search: Partial<z.infer<typeof BackofficeScheduledReportsSearchSchema>>) => {
    search.filterBy = search.filterBy || {}
    return BackofficeScheduledReportsSearchSchema.parse(search)
  },
})
